import * as SingleSelect from '@givebutter/primitives/single-select';

interface NegationOptionsProps {
    resource?: string;
}

const NegationOptions = ({ resource = 'Items' }: NegationOptionsProps) => (
    <>
        <SingleSelect.Item value="has">
            <SingleSelect.ItemText>Has {resource}</SingleSelect.ItemText>
        </SingleSelect.Item>
        <SingleSelect.Item value="doesnt_have">
            <SingleSelect.ItemText>Doesn't have {resource}</SingleSelect.ItemText>
        </SingleSelect.Item>
    </>
);

export { NegationOptions };
export type { NegationOptionsProps };
